import { useEffect, useMemo, useState, useContext, useRef } from "react"
import _, { values } from "underscore";
import { Urls } from "../../../services/Urls";
import services from "../../../services/services";
import { ToastContext } from "../../../context/ToastContext";

export const useHistory = () => {
    const { showSuccess, showInfo, showError } = useContext(ToastContext);
    const [tableList, setTableList] = useState([])
    const [showPagination, setshowPagination] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalRecords, settotalRecords] = useState(0);
    const [totalPages, settotalPages] = useState(0);
    const [displayPageOutOfTotal, setdisplayPageOutOfTotal] = useState("");
    const [columnDefs, setColumnDefs] = useState([]);
    const [rowData, setrowData] = useState([]);
    const [tableName, settableName] = useState('');
    const currentTable = useRef('')
    const  [ loader,setLoader] = useState({
        listLoader:false,
        gridLoader:false
    })


    useEffect(() => {
        getTableHistoryData()
    }, [])

    useEffect(() => {
        currentTable.current = tableName
    },[tableName])


    const getTableHistoryData = async () => {
        setLoader((prevState) => ({
            ...prevState,
            listLoader:true
        }))
        try {
            const res = await services.getInvokeRemote('GET', Urls('GETHISTORYTABLEDATA'))
            if (res?.body?.data?.history_list) {
                setTableList(res?.body?.data?.history_list)
                setLoader((prevState) => ({
                    ...prevState,
                    listLoader:false
                }))
            }
        } catch (error) {
            showError("Error", error?.response?.data?.errorMessage);
            console.error(error);
        }
    }

    const getHistoryData = async (row,pageNumber) => {
        setLoader((prevState) => ({
            ...prevState,
            gridLoader:true
        }))
        const payload = {
            "table_name":row,
            "page_number": pageNumber
        }
        settableName(row)
        if(pageNumber === 0) {
             setCurrentPage(0)
        }
        try {
            const res = await services.getInvokeRemote('POST', Urls('GETHISTORYDATA'), payload)
            if (res?.body?.data?.history_data) {
                const historyCol = res.body.data.history_data
                if (!_.isEmpty(historyCol)) {
                    const column = Object.keys(historyCol[0]).map(col => {
                        return {
                            field: col,
                            headerName: col?.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase()),
                            width: 190,
                            cellStyle: { textAlign: "center" }
                        }
                    });
                    setColumnDefs(column)
                    setrowData(historyCol)
                    if (!_.isEmpty(res.body.data.page_count)) {
                        setshowPagination(true);
                        settotalRecords(res?.body?.data?.page_count[0]?.total_records);
                        setdisplayPageOutOfTotal(res?.body?.data?.page_count[0]?.paging);
                        settotalPages(res?.body?.data?.page_count[0]?.total_pages)
                    }
                    setLoader((prevState) => ({
                        ...prevState,
                        gridLoader:false
                    }))
                }
                

            }



        } catch (error) {
            showError("Error", error?.response?.data?.errorMessage);
            console.error(error);
        }
    }
    const handlePageChange = (e) => {        
        setCurrentPage(e);
        getHistoryData(tableName,e - 1);
    };



    return useMemo(() => ({
        getTableHistoryData, tableList, getHistoryData,
        showPagination, totalRecords, totalPages, currentPage,
        displayPageOutOfTotal, handlePageChange, columnDefs, rowData,tableName,loader
    }), [tableList, getHistoryData, showPagination, totalRecords, totalPages, currentPage,
        displayPageOutOfTotal, handlePageChange, columnDefs, rowData,tableName,loader])
}